export const ErrorCodes = [
    // ErrorCodesAzPersonsActionDelete
    {
        text: 'lang_AZ_ERROR_CANNOT_DELETE_AZ_ENTRY',
        value: 1
    },
    {
        text: 'lang_LABEL_RELEASES_ERROR_CANNOT_CREATE_GVL_FILE',
        value: '1LR'
    },
    {
        text: 'lang_LABEL_RELEASES_ERROR_CANNOT_CREATE_GEMA_TONIS_FILE',
        value: '2LR'
    }
]